import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import PackagingUsage34_1bTable from "./Table";
import { ShowHide } from "../../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const PackagingUsage34_1b = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("PACKAGING_USAGE") || "Packaging Usage"}
        subDescription={t("PACKAGING_USAGE_34_1B_DESC") || "Enter packaging usage for custom manufacturing"}
        isNormal={true}
        number={"34.1b"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`packaging-usage-34-1b-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <PackagingUsage34_1bTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default PackagingUsage34_1b;
